import { ContentItem } from 'kentico-cloud-delivery';

import get from 'lodash/get';

export default class AccordionItem extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`,
    });
  }

  get title() {
    return get(this, '_title.text', '');
  }

  get text() {
    return get(this, '_text.value', '');
  }

  get id() {
    return get(this, 'system.id', '');
  }

  get videoLink() {
    return get(this, '_video_link.value', '');
  }

  get image() {
    return get(this, '_image.value[0].url', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/FAQAccordionItem.model.js